<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">

    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data" v-if="order_data">

      <div class="vx-row">
        <div class="vx-col lg:w-1/2 w-full">
          <vx-card :title="'Инфо о заказе #' + order_data.pl_id" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Заказ создан</td>
                <td>{{ order_data.pl_createdAt }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Статус</td>
                <td>
                  <v-select
                  :options="['ожидает обработки','недозвон','подтвержден','отменен','оплачен','оформлен возврат','сформирован для отправки','отправлен получателю','доставлен','выдан']"
                  :value="order_data.pl_status"
                  @input="changeStatus"
                  />
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Оплачен</td>
                <td>
                  <vs-switch color="primary" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" v-model="paidOrNot">
                    <span slot="on">YES</span>
                    <span slot="off">NO</span>
                  </vs-switch>
                </td>
              </tr>
              <tr>
                <td class="font-semibold">Телефон</td>
                <td>{{ order_data.pl_contact_number }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Адрес</td>
                <td>{{ order_data.pl_address }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Время</td>
                <td>{{ order_data.pl_time }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Тип доставки</td>
                <td>{{ order_data.pl_order_type }}</td>
              </tr>
            </table>
          </vx-card>
        </div>

        <div class="vx-col lg:w-1/2 w-full">
          <vx-card title="Клиент" class="mb-base">
            <table>
              <tr>
                <td class="font-semibold">Telegram ID</td>
                <td>{{ user_data.user_id }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Имя</td>
                <td>{{ user_data.name }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Username</td>
                <td>{{ user_data.username }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Телефон</td>
                <td>{{ user_data.phone_number }}</td>
              </tr>
            </table>
          </vx-card>
        </div>
      </div>

    </div>

    <vx-card id="invoice-container">

        <!-- INVOICE CONTENT -->
        <div class="p-base">
            <!-- INVOICE TASKS TABLE -->
            <vs-table hoverFlat :data="basket_data.tasks">
                <!-- HEADER -->
                <template slot="thead">
                    <vs-th class="pointer-events-none">Наименование</vs-th>
                    <vs-th class="pointer-events-none">Описание</vs-th>
                    <vs-th class="pointer-events-none">Количество</vs-th>
                    <vs-th class="pointer-events-none">Цена</vs-th>
                    <vs-th class="pointer-events-none">Сумма</vs-th>
                    <vs-th class="pointer-events-none">Action</vs-th>
                </template>

                <!-- DATA -->
                <template slot-scope="{data}">
                    <vs-tr v-for="(tr, index) in data" :key="index">
                        <vs-td :data="data[index].name_RU">{{ data[index].name_RU }}</vs-td>
                        <vs-td :data="data[index].description_RU">{{ data[index].description_RU }}</vs-td>
                        <vs-td :data="data[index].quantity">
                          <vs-input-number size="medium" v-model="data[index].quantity" @input="changeQuantity(basket_data.tasks[index].quantity, basket_data.tasks[index].id)"/>
                        </vs-td>
                        <vs-td :data="data[index].price">{{ data[index].price }} So'm</vs-td>
                        <vs-td :data="data[index].quantity*data[index].price">{{ data[index].quantity*data[index].price }} So'm</vs-td>

                        <vs-td>
                          <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteRow(basket_data.tasks[index].id)" />                          
                        </vs-td>
                    </vs-tr>
                </template>
            </vs-table>

            <!-- INVOICE SUMMARY TABLE -->
            <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="basket_data.tasks">
                <vs-tr>
                    <vs-th class="pointer-events-none">TOTAL</vs-th>
                    <vs-td>{{ basket_data.total }} USD</vs-td>
                </vs-tr>
            </vs-table>
        </div>
    </vx-card>
  </div>
</template>

<script>
import moduleUserManagement from '@/store/user-management/moduleUserManagement.js'
import vSelect from 'vue-select'

export default {
  components: {
    'v-select': vSelect,
  },
  data() {
    return {
      user_data: {},
      order_data: {},
      user_not_found: false,
      basket_data: {
          tasks: [],
          subtotal: 114000,
          discountPercentage: 5,
          discountedAmount: 5700,
          total: 108300,
      }
    }
  },
  watch: {
    'basket_data.tasks'(val){
      console.log(val)
    }
  },
  computed: {
    paidOrNot: {
      get() {
        return this.order_data.pl_paid=='yes'?true:false
      },
      set(val) {
        console.log(val)
        this.order_data.pl_paid = (val?'yes':'no')
        this.$http.post(`https://tez.public.uz/fserver/updateRow/Botorders/${this.order_data.pl_id}`, {
          paid: (val?'yes':'no')
        }).then(() => {
        })
      }
    },
    userAddress() {
      let str = ""
      for(var field in this.user_data.location) {
        str += field + " "
      }
      return str
    }
  },
  methods: {
    changeStatus(val){
      this.order_data.pl_status = val
      this.$http.post(`https://tez.public.uz/fserver/updateRow/Botorders/${this.order_data.pl_id}`, {
        status: val
      }).then(() => {
      })
    },
    changeQuantity(quantity, id){
      this.$http.post(`https://tez.public.uz/fserver/updateRow/Botbaskets/${id}`, {
        quantity: quantity
      }).then(() => {
        this.basket_data.total = this.basket_data.tasks.reduce((a, {quantity, price}) => a + (quantity*price), 0)
      })
    },
    async deleteRow(id) {
      if (confirm('Are you sure to delete?')) {
        // this.$store.dispatch("dataList/removeItem", id).catch(err => { console.error(err) })
        try {
          let obj = {}
          obj['table'] = 'Botbaskets'
          obj['id'] = id
          await this.$http.post(`https://tez.public.uz/fserver/deleteRow/Botbaskets/`, obj).then(response => {
            console.log(response)
          })
          await this.$vs.notify({
            title:'Success',
            text:'The data has been deleted!',
            color:'success',
            position:'top-right'
          })
          await this.getTasks()
        } catch (error) {
          this.$vs.notify({
            title:'Danger',
            text:'The data has not been deleted!' + error,
            color:'danger',
            position:'top-right'
          })
        }
      }
    },
    async getTasks(){
      this.basket_data.tasks = await this.$http.get(`https://tez.public.uz/fserver/getXjoin/xjoin?_join=pl.Botbaskets,_j,pi.Botitems&_on1=(pl.itemid,eq,pi.id)`, {
          params: {
              "_size": 1000,
              "_p": 1,
              "_where": `(pl.botid,eq,${this.$store.state.AppActiveUser.botId})~and(pl.orderid,eq,${this.$route.params.order_id})`,
              "_sort": 'pl.id',
              "_fields": 'pl.id,pl.quantity,pi.name_RU,pi.price,pi.description_RU,pi.measurement',
              "_tableconstruction_version": "vertri",
              "_zeTable": 'Botbaskets',
              "_table_name": 'Botbaskets'
          }
      }).then(response => {
          return response.data.records
      })
      this.basket_data.total = this.basket_data.tasks.reduce((a, {quantity, price}) => a + (quantity*price), 0)
    },
    confirmDeleteRecord() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirm Delete`,
        text: `You are about to delete "${this.user_data.username}"`,
        accept: this.deleteRecord,
        acceptText: "Delete"
      })
    },
    deleteRecord() {
      /* Below two lines are just for demo purpose */
      this.$router.push({name:'app-user-list'});
      this.showDeleteSuccess()

      /* UnComment below lines for enabling true flow if deleting user */
      // this.$store.dispatch("userManagement/removeRecord", this.user_data.id)
      //   .then(()   => { this.$router.push({name:'app-user-list'}); this.showDeleteSuccess() })
      //   .catch(err => { console.error(err)       })
    },
    showDeleteSuccess() {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    }
  },
  async created() {
    // Register Module UserManagement Module
    if(!moduleUserManagement.isRegistered) {
      this.$store.registerModule('userManagement', moduleUserManagement)
      moduleUserManagement.isRegistered = true
    }
    this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$store.state.AppActiveUser.scjw

    this.order_data = await this.$http.get(`https://tez.public.uz/fserver/getXjoin/xjoin?_join=pl.Botorders,_lj,pu.Botusers&_on1=(pl.user_id,eq,pu.id)`, {
        params: {
            "_size": 1,
            "_p": 1,
            "_where": `(pu.botid,eq,${this.$store.state.AppActiveUser.botId})~and(pl.id,eq,${this.$route.params.order_id})`,
            "_sort": 'pl.id',
            "_fields": 'pl.id,pl.user_id,pu.name,pl.status,pl.contact_number,pl.address,pl.time,pl.order_type,pl.createdAt,pl.paid',
            "_tableconstruction_version": "vertri",
            "_table_name": 'Botorders',
            "_zeTable": 'Botorders',
            "_use_prefix": true
        }
    }).then(response => {
        return response.data.records[0]
    })
    this.user_data = await this.$http.get(`https://tez.public.uz/fserver/getall/Botusers`, {
        params: {
            "_size": 1,
            "_p": 1,
            "_where": `(id,eq,${this.order_data.pl_user_id})`,
            "_sort": 'id',
            "_fields": '-',
            "_tableconstruction_version": "vertri",
            "_zeTable": 'Botusers',
            "_table_name": 'Botusers'
        }
    }).then(response => {
        return response.data.records[0]
    })
    await this.getTasks()
    // this.$store.dispatch("userManagement/fetchUser", userId)
    //   .then(res => { this.user_data = res.data })
    //   .catch(err => {
    //     if(err.response.status === 404) {
    //       this.user_not_found = true
    //       return
    //     }
    //     console.error(err) })
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }

}

</style>
